
import { FaTelegram } from "react-icons/fa6";
import { FaSquareXTwitter } from "react-icons/fa6";
import { socials } from "../../links";
import { FaMedium } from "react-icons/fa";
import { Link } from "react-router-dom";
import { BsReddit } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { FaTiktok } from "react-icons/fa6";
export default function SocialMediaLinks({ className = '' }) {
    return (
        <>
            <div className={`flex gap-2 items-center  ${className}`}>
                <Link to={socials.tg} target='_blank'       rel="noreferrer noopener"    >
                    <FaTelegram className='text-xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
                </Link>
                <Link to={socials.x} target='_blank'       rel="noreferrer noopener"     >
                    <FaSquareXTwitter className='text-xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
                </Link>
                <Link to={socials.medium} target='_blank'       rel="noreferrer noopener"    >
                    <FaMedium className='text-xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
                </Link>
                <Link to={socials.medium} target='_blank'       rel="noreferrer noopener"    >
                    <BsReddit className='text-xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
                </Link>
                <Link to={socials.instagram} target='_blank'       rel="noreferrer noopener"     >
                    <BsInstagram className='text-xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
                </Link>
                <Link to={socials.tikTok} target='_blank'       rel="noreferrer noopener"   >
                    <FaTiktok className='text-xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
                </Link>
            </div>
        </>


    )


}